module.exports = __webpack_public_path__ + "img/icon-plus.9af16751.svg";